import React, { useEffect, useState } from 'react';
import Checkbox from '@material-ui/core/Checkbox';

function TriStateCheckbox(props) {
    const { checked,onChange, styles } = props;
    const [localChecked, setLocalChecked] = useState(checked ?? null);
    useEffect(() => setLocalChecked(checked ?? null), [checked]);

  const handleChange = () => {
    switch (localChecked) {
      case true:
        setLocalChecked(false)
        onChange(false);
        break;
      case false:
        setLocalChecked(null)
        onChange(null);
        break;
      default:
        setLocalChecked(true);
        onChange(true)
        break;
    }
  };

  return (   
      <Checkbox
      checked={!!localChecked}
      indeterminate={localChecked === null}
      color={"primary"}
      icon={<div style={{pointerEvents: "none"}} className="dx-checkbox-container"><span className="dx-checkbox-icon"></span></div>}
      checkedIcon={<div style={{pointerEvents: "none"}} className="dx-checkbox-checked dx-checkbox-container"><span className="dx-checkbox-icon"></span></div>}
      indeterminateIcon={<div style={{pointerEvents: "none"}} className="dx-checkbox-indeterminate dx-checkbox-container"><span className="dx-checkbox-icon"></span></div>}
      onChange={handleChange}
      style={styles}
    />
  );
};

export {TriStateCheckbox}